module.exports = __webpack_public_path__ + "img/full-darkwaters-4.143cc8d7.jpg";